var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scene scene--focused"},[_c('div',{staticClass:"scene__island-wrapper"},[_vm._l((_vm.islandCount),function(i){return [(_vm.slideTypes.includes(i - 1))?_c(`Island${i}`,{key:i,tag:"Component",class:{
          // activeTheme can be 0 so we have to explecitly compare for false
          'island--active': _vm.activeTheme !== false && _vm.activeTheme === i - 1,
          'island--hidden': _vm.activeTheme !== false && _vm.activeTheme !== i - 1
        }}):_c('div',{key:i,staticClass:"island"})]})],2),_c('div',{staticClass:"scene__sky-wrapper"},_vm._l((5),function(n){return _c('Sky',{key:n,staticClass:"sky"})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }